/* ============================================================
   custom.js — このストア固有のカスタムJS
   2026-08-20 五十嵐 新規作成

   全案件共通の規約として、テーマ本体（*.bundle.js / theme.js 等）には手を入れず、
   追加のスクリプトはすべてこのファイルに追記する。
   読み込みは layout/theme.liquid で行っている。
   ============================================================ */

/* ------------------------------------------------------------
   デニムフィットガイドの背景動画
   2026-08-20 五十嵐 追加

   画面幅に応じてPC用・スマホ用のどちらか一方だけを読み込む。
   src を最初から書いてしまうと両方が落ちてくるため、Liquid側では
   data 属性に候補を持たせ、実際の読み込みはここで決める。
   動きを抑える設定にしている環境では動画を読み込まず、ポスター画像のまま止める。
   ------------------------------------------------------------ */
(function () {
  var PC_QUERY = '(min-width: 750px)';

  function setup(video) {
    if (video.dataset.rbVideoReady === '1') return;

    var isPc = window.matchMedia(PC_QUERY).matches;
    var src = isPc ? video.dataset.srcPc : video.dataset.srcSp;
    var poster = isPc ? video.dataset.posterPc : video.dataset.posterSp;

    if (poster) video.setAttribute('poster', poster);
    if (!src) return;

    video.dataset.rbVideoReady = '1';
    video.setAttribute('preload', 'metadata');
    video.src = src;

    var play = video.play();
    if (play && typeof play.catch === 'function') {
      // 自動再生が拒否された場合はポスター画像のままにする
      play.catch(function () {});
    }
  }

  function init() {
    var videos = document.querySelectorAll('video[data-rb-video]');
    if (!videos.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduced.matches) return;

    Array.prototype.forEach.call(videos, setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // テーマエディタでセクションを読み込み直したときにも効かせる
  document.addEventListener('shopify:section:load', init);
})();
